import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import { CloseIcon } from 'components/icon'
import styles from './Modal.scss'

const Modal = props => (
	<div styleName={
		cn({
			Modal: true,
			'Modal--visible': props.visible,
			'Modal--fullscreen': props.fullscreen,
		})
	}>
		<div styleName="container">
			<button styleName="close" onClick={props.close}>
				<CloseIcon />
			</button>
			{props.children}
		</div>
	</div>
)

Modal.propTypes = {
	children: PropTypes.any,
	visible: PropTypes.bool.isRequired,
	fullscreen: PropTypes.bool,
	close: PropTypes.func.isRequired,
}

Modal.defaultProps = {
	visible: false,
	fullscreen: false,
	close: () => { },
}

export default CSSModules(Modal, styles, { allowMultiple: true })
